import React, { useEffect, useState } from "react";
import "./career-list.css"; // ⬅ new styles below
import CareerRow from "./CareerRow"; // ⬅ new component
import CareerForm from "./CareerForm";

const API = "https://api.ainfotech.com.np";

export default function CareerList() {
  const [items, setItems] = useState([]);
  const [status, setStatus] = useState("open");
  const [page, setPage] = useState(1);
  const [showForm, setShowForm] = useState(false);
  const [editing, setEditing] = useState(null);
  const limit = 12;

  const load = async () => {
    const params = new URLSearchParams({
      ...(status ? { status } : {}),
      page: String(page),
      limit: String(limit),
    });
    const res = await fetch(`${API}/api/careers?${params}`, { credentials: "include" });
    const data = await res.json();
    if (!res.ok) throw new Error(data?.error || "Failed");
    setItems(data.items || []);
  };

  useEffect(() => { load().catch(e => alert(e.message)); }, [page, status]);

  const onDelete = async (id) => {
    if (!window.confirm("Delete this job?")) return;
    const res = await fetch(`${API}/api/careers/${id}`, { method: "DELETE", credentials: "include" });
    const data = await res.json();
    if (!res.ok) return alert(data?.error || "Delete failed");
    load();
  };

  const showPager = page > 1 || (items?.length || 0) === limit;

  return (
    <div className="career-admin">
      {/* Toolbar */}
      <div className="toolbar">
        <h2 className="toolbar__title">Careers</h2>
        <div className="toolbar__actions">
          <select
            className="sel"
            value={status}
            onChange={(e) => { setStatus(e.target.value); setPage(1); }}
          >
            <option value="open">open</option>
            <option value="closed">closed</option>
            <option value="draft">draft</option>
            <option value="">all</option>
          </select>
          <button
            className="btn btn--cta"
            onClick={() => { setEditing(null); setShowForm(true); }}
          >
            <span className="i i-plus" aria-hidden="true" /> New
          </button>
        </div>
      </div>

      {/* Form panel */}
      {showForm ? (
        <div className="panel">
          <div className="panel__head">
            <h3 className="panel__title">{editing ? "Edit Job" : "Create Job"}</h3>
            {/* <button
              className="btn btn--close"
              onClick={() => { setShowForm(false); setEditing(null); }}
            >
              Close
            </button> */}
          </div>

          <CareerForm
            initial={editing}
            onSaved={() => { setShowForm(false); setEditing(null); load(); }}
            onCancel={() => { setShowForm(false); setEditing(null); }}
          />
        </div>
      ) : (
        <>
          {/* Empty state */}
          {items.length === 0 ? (
            <div className="empty">
              <div className="empty__icon">📄</div>
              <div className="empty__title">No jobs found</div>
              <div className="empty__desc">Try changing the filter or create a new job.</div>
              <button
                className="btn btn--cta"
                onClick={() => { setEditing(null); setShowForm(true); }}
              >
                <span className="i i-plus" /> Create first job
              </button>
            </div>
          ) : (
            <div className="job-list">
              {items.map((it) => (
                <CareerRow
                  key={it.id}
                  item={it}
                  onEdit={(row) => { setEditing(row); setShowForm(true); }}
                  onDelete={onDelete}
                />
              ))}
            </div>
          )}

          {/* Pagination (only if needed) */}
          {showPager && (
            <div className="pager">
              <button
                className="pill"
                disabled={page === 1}
                onClick={() => setPage((p) => Math.max(1, p - 1))}
              >
                <span className="i i-left" aria-hidden="true" /> Prev
              </button>
              <span className="badge">Page {page}</span>
              <button className="pill" onClick={() => setPage((p) => p + 1)}>
                Next <span className="i i-right" aria-hidden="true" />
              </button>
            </div>
          )}
        </>
      )}
    </div>
  );
}
